/*
 © Copyright 2026 Daikin Industries, Ltd. All rights reserved.

 This software is the proprietary information of Daikin Industries, Ltd.
 By using this software, you agree to the following terms:

 1. You are granted a revocable non-exclusive, non-transferable license to use this software.
 2. You agree not to modify, distribute, or create derivative works based on this software.
 3. Unauthorized copying, distribution, or use of any portion of this software is strictly prohibited.
 4. This software is protected by copyright laws and international treaties.
 5. Any violation of these terms will result in the termination of your license and may result in legal action.
 6. This is Daikin's proprietary software and may not be used in an unauthorized manner or without express authorization from Daikin.
*/

import { Routes } from '@angular/router';
import { MainLayoutComponent } from './shared/main-layout/main-layout.component';
import { ApiCatalogComponent } from './api-catalog/api-catalog.component';
import { MainPageComponent } from './main-page/main-page.component';
import { ApiViewerComponent } from './api-viewer/api-viewer.component';
import { ApiMeshComponent } from './api-mesh/api-mesh.component';
import { DynamicApiViewerComponent } from './dynamic-api-viewer/dynamic-api-viewer.component';
import { UserRegistrationConfirmationComponent } from './api-mesh/components/user-registration-confirmation/user-registration-confirmation.component';
import { MsalGuard } from '@azure/msal-angular';
import { configRedirectGuard } from './shared/guards/config-redirect.guard';

export const routes: Routes = [
    {
        path: 'login',
        loadChildren: () => import('./admin/admin.module').then(m => m.AdminModule)
    },
    {
        path: '',
        component: MainLayoutComponent,
        children:[
            {path: '', component: MainPageComponent},
            {path: 'apis', component: ApiCatalogComponent, canActivate: [MsalGuard]},
            {path: 'api-viewer/:fileIdentifier', component: ApiViewerComponent, canActivate: [MsalGuard]},
            {path: 'dynamic-api-viewer', component: DynamicApiViewerComponent, canActivate: [MsalGuard]},
            {
                path: 'api-mesh/user-registration',
                canActivate: [configRedirectGuard('userRegistration')],
                children: []
            },
            {
                path: 'api-mesh/user-registration-confirmation',
                component: UserRegistrationConfirmationComponent
            },
            {
                path: 'api-mesh/application-registration',
                canActivate: [configRedirectGuard('applicationRegistration')],
                children: []
            },
            {
                path: 'api-mesh/getting-started',
                redirectTo: '/api-mesh/overview#getting-started',
                pathMatch: 'full'
            },
            {
                path: 'api-mesh/how-to-use-api-mesh',
                redirectTo: '/api-mesh/overview#how-to-use-api-mesh',
                pathMatch: 'full'
            },
            {
                path: 'api-mesh',
                component: ApiMeshComponent,
                canActivate: [MsalGuard],
                data: { section: 'overview' }
            },
            {
                path: 'api-mesh/overview',
                component: ApiMeshComponent,
                canActivate: [MsalGuard],
                data: { section: 'overview' }
            },
            {
                path: 'api-mesh/explorer',
                component: ApiMeshComponent,
                canActivate: [MsalGuard],
                data: { section: 'api-explorer' }
            },
            {
                path: 'api-mesh/haystack',
                component: ApiMeshComponent,
                canActivate: [MsalGuard],
                data: { section: 'haystack' }
            },
            {
                path: 'api-mesh/samples',
                component: ApiMeshComponent,
                canActivate: [MsalGuard],
                data: { section: 'samples' }
            }
        ]
    },
    {
        path: 'admin',
        canActivate: [MsalGuard],
        loadChildren: () => import('./admin/admin.module').then(m => m.AdminModule)
    },
    {
        path: '**',
        redirectTo: ''
    }
];
